<app-navbar></app-navbar>


<section class="pt-0 pb-0" id="home">
    <div class="slider-bg">
        <ul class="slides">
            <li>
                <owl-carousel-o [options]="customOptions" class="owl-btn-center-lr">
                    <ng-template carouselSlide *ngFor="let slide of slideStore">
                        <div class="slide-img" style="background-image: url('{{slide.image}}')">
                            <div class="hero-text-wrap">
                                <div class="hero-text white-color">
                                    <div class="container text-center">
                                        <h1 class="title raleway-font">{{slide.introtext}}</h1>
                                        <h2 class="white-color font-700">{{slide.title}}</h2>
                                        <h3 class="sub-title font-100 raleway-font">{{slide.subtitle}}</h3>
                                        <a (click)="scrollToSection('contact')" [ngClass]="slide.btnSlide"><span>{{slide.btnText}} <i
                                                    class="icofont icofont-arrow-right"></i></span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </li>
        </ul>
    </div>
</section>

<section class="white-bg">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-sm-23 text-left sm-mt-0 d-flex align-items-center">
                <div class="d-block pl-30 sm-pl-0">
                    <div class="section-title mb-50">
                        <h2 class="raleway-font mt-0">Bienvenue chez Mazabu</h2>
                        <h1 class="raleway-font mt-30 font-50px font-300"><span class="type-it default-color">{{ displayedText }}</span></h1>
                    </div>
                    <p>Nous sommes une entreprise spécialisée dans les services informatiques et la transformation numérique des organisations.
                        Nous accompagnons les entreprises, institutions publiques et organisations privées dans leur modernisation technologique, l’optimisation de leurs processus et la sécurisation de leurs données.
                        Dans un monde où le numérique est devenu un levier stratégique incontournable, Mazabu se positionne comme un partenaire fiable, innovant et orienté résultats.</p>
                    <p class="mt-30 mb-0"><a class="btn btn-lg btn-gradient-secondary btn-circle" (click)="scrollToSection('services')">Nos services</a></p>
                </div>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="responsive-screen mt-0">
                    <img src="assets/images/macbook.png" class="img-responsive" alt="laptop">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="bordered-bg white-bg lg-section xs-pb-100 xs-pt-100">
    <div class="col-md-6 col-sm-6 bg-flex bg-flex-right">
        <div class="bg-flex-holder bg-flex-cover" style="background-image: url(assets/images/front-office.jpg);"></div>
    </div>
    <div class="container">
        <div class="col-md-5 col-sm-6">
            <div class="section-title mb-50">
                <h2 class="raleway-font default-color mt-0 font-20px">Pourquoi choisir</h2>
                <h1 class="raleway-font mt-0 font-50px font-300">Mazabu?</h1>
            </div>
            <p>Grâce à une équipe expérimentée, multidisciplinaire et passionnée par la technologie, Mazabu s’engage à livrer des solutions fiables, évolutives et durables. Nous mettons un point d’honneur à instaurer une relation de confiance avec nos clients, basée sur la transparence, l’écoute et l’excellence opérationnelle.</p>
            <p>Choisir Mazabu, c’est choisir un partenaire qui comprend vos enjeux, anticipe les évolutions technologiques et vous aide à construire l’avenir numérique de votre organisation.</p>
            <p class="mt-30 mb-0"><a (click)="scrollToSection('expertise')" class="btn btn-lg btn-gradient-secondary btn-circle">En savoir plus</a></p>
        </div>
    </div>
</section>

<section class="white-bg lg-section xs-pt-100 xs-pb-100">
    <div class="col-md-6 col-sm-6 bg-flex bg-flex-left">
        <div class="bg-flex-holder bg-flex-cover" style="background-image: url(assets/images/conference_room.jpg);"></div>
    </div>
    <div class="container">
        <div class="col-md-5 col-sm-6 offset-md-7 offset-md-6">
            <div class="section-title mb-50">
                <h2 class="raleway-font default-color mt-0 font-20px">Notre</h2>
                <h1 class="raleway-font mt-0 font-50px font-300">Mission</h1>
            </div>
            <p>Notre mission est de simplifier la technologie afin qu’elle serve efficacement vos objectifs métiers. Nous croyons que le numérique doit être accessible, sécurisé et adapté aux réalités locales tout en respectant les standards internationaux. C’est pourquoi nous proposons des solutions sur mesure, conçues pour répondre aux besoins spécifiques de chaque client, quel que soit son secteur d’activité.</p>
            <p class="mt-30 mb-0"><a (click)="scrollToSection('expertise')" class="btn btn-lg btn-gradient-primary btn-circle">En savoir plus</a></p>
        </div>
    </div>
</section>

<section class="default-bg pt-80 pb-80">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-title mb-50 white-color text-center">
                    <h1 class="raleway-font remove-margin font-50px font-300">Notre approche</h1>
                </div>
            </div>
        </div>
        <div class="row our-process-style-02">
            <div *ngFor="let step of steps" class="col-md-3 col-sm-6 col-xs-12 line xs-mb-30 sm-mb-30">
                <div class="icon-wrap white-bg">
                    <div class="icon">
                        <i [ngClass]="step.icon"></i>
                    </div>
                </div>
                <div class="text-center white-color">
                    <h4 class="font-500">{{step.title}}</h4>
                    <p class="mb-0">{{step.desc}}</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="grey-bg" id="about">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font default-color">À propos de nous</h2>
                    <h1 class="raleway-font">Notre historique</h1>
                </div>
                <p>Mazabu est née, en 2021, de la volonté de mettre la technologie au service du développement des entreprises et des institutions. Face aux défis croissants liés à la digitalisation, à la gestion des données et à l’efficacité opérationnelle, nous avons décidé de créer une structure capable d’apporter des solutions concrètes, adaptées et durables.</p>
                <p>Notre vision est claire : accompagner la transformation numérique de manière pragmatique, en tenant compte des réalités organisationnelles, humaines et économiques de nos clients. Nous ne proposons pas des solutions génériques, mais des outils et des méthodes pensés pour créer de la valeur réelle et mesurable.</p>
                <p>Mazabu s’appuie sur une équipe de professionnels expérimentés dans les domaines du développement logiciel, de l’architecture des systèmes, de la sécurité informatique, de l’assurance qualité et de la gestion de projets. Cette expertise nous permet de couvrir l’ensemble du cycle de vie d’un projet informatique, depuis la phase de réflexion stratégique jusqu’au déploiement et à l’amélioration continue.</p>
                <p>Nos valeurs sont au cœur de notre manière de travailler : professionnalisme, intégrité, innovation et engagement. Nous croyons à une collaboration étroite avec nos clients, fondée sur l’écoute active et la compréhension approfondie de leurs besoins.</p>
            </div>
        </div>

        <div class="row mt-50">
            <div class="team-slider">
                <div class="col-md-12">
                    <owl-carousel-o [options]="customOptionsTwo" class="owl-btn-center-lr">
                        <ng-template carouselSlide *ngFor="let slide of slideStoreTwo">
                            <div class="team-member">
                                <div class="team-thumb">
                                    <div class="thumb-overlay"></div>
                                    <img src="assets/images/team/{{slide.image}}" alt="">
                                    <div [ngClass]="slide.index === 0 ? 'member-info text-center secondary-bg' : 'member-info text-center default-bg'">
                                        <h3>{{slide.subtitle}}</h3>
                                        <span class="title">{{slide.title}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </owl-carousel-o>
                </div>
            </div>
        </div>

    </div>
</section>

<section class="white-bg pb-80" id="services">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font default-color">Ce que nous offrons</h2>
                    <h1 class="raleway-font">Nos services</h1>
                </div>
                <p>Mazabu propose une gamme complète de services informatiques destinés à soutenir la performance et la croissance des organisations. Notre approche repose sur l’adaptation des technologies aux besoins métiers, avec un objectif constant : améliorer l’efficacité, la sécurité et la qualité des systèmes d’information.</p>
            </div>
        </div>

        <div class="row mt-50">
            <div *ngFor="let service of services" class="col-md-4 col-sm-4 col-xs-12 mb-30 feature-box text-center hover-effect">
                <div class="default-bg-icon mb-20">
                    <i [ngClass]="service.icon"></i>
                </div>
                <h5 class="mt-10">{{service.title}}</h5>
                <p class="font-400">{{service.desc}}</p>
            </div>
        </div>

    </div>
</section>

<section class="gray-bg" id="expertise">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font default-color">Notre</h2>
                    <h1 class="raleway-font">Expertise</h1>
                </div>
                <p>Chez Mazabu, nous avons développé une approche méthodique et orientée résultats pour garantir le succès des projets informatiques. Chaque collaboration débute par une phase d’analyse approfondie, durant laquelle nous prenons le temps de comprendre les enjeux métiers, les contraintes techniques et les objectifs stratégiques de nos clients.</p>
                <p>Nous privilégions une démarche structurée, combinant bonnes pratiques, standards internationaux et agilité. Cela nous permet d’adapter nos méthodes aux contextes spécifiques tout en assurant une qualité constante. La communication transparente et le suivi régulier des projets sont au cœur de notre façon de travailler.</p>
                <p>Notre expertise couvre l’ensemble du cycle de vie des solutions numériques : étude de faisabilité, conception, développement, tests, déploiement et maintenance. Nous accordons une importance particulière à l’assurance qualité, afin de livrer des solutions fiables, performantes et évolutives.</p>
                <p>Mazabu mise également sur l’amélioration continue. Nous évaluons régulièrement nos méthodes et intégrons les nouvelles technologies et tendances du marché afin de rester à la pointe de l’innovation. Cette capacité d’adaptation nous permet de proposer des solutions pérennes, capables d’évoluer avec les besoins de nos clients.</p>
                <p>En choisissant Mazabu, vous bénéficiez d’un partenaire engagé, capable de transformer des idées complexes en solutions concrètes, tout en maîtrisant les risques et les délais. Notre objectif est simple : contribuer durablement à la réussite de vos projets numériques.</p>
            </div>
        </div>
    </div>
</section>

<!-- <div class="grey-bg pt-120 pb-120">
    <div class="container">
        <div class="row">
            <div class="client-slider">
                <owl-carousel-o [options]="customOptionsFour" class="owl-btn-center-lr">
                    <ng-template carouselSlide *ngFor="let slide of slideStoreFour">
                        <div class="client-logo">
                            <img class="img-responsive" src="{{slide.image}}" alt="01" />
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>
        </div>

    </div>
</div> -->

<section class="parallax-bg fixed-bg" style="background-image: url('assets/images/background/boat.jpg')">
    <div class="overlay-bg"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center parallax-content height-400px">
                <div class="center-layout">
                    <div class="v-align-middle">
                        <h1 class="font-400 white-color raleway-font xs-font-40px">Votre guichet unique pour la transformation numérique</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>



<section class="white-bg transition-none" id="contact">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font default-color">Restez en contact</h2>
                    <h1 class="raleway-font">Contactez-nous</h1>
                </div>
                <p>Vous avez un projet, une idée ou un besoin spécifique en matière de services informatiques ? Mazabu est à votre écoute. Nous croyons que chaque projet commence par un échange, une compréhension mutuelle et une vision partagée des objectifs à atteindre.</p>
                <p>Notre équipe est disponible pour répondre à vos questions, analyser vos besoins et vous proposer des solutions adaptées. Que vous soyez une entreprise privée, une institution publique ou une organisation en pleine transformation, nous sommes prêts à vous accompagner à chaque étape de votre parcours numérique.</p>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row mt-70">
            <div class="col-md-6 col-sm-6 col-xs-12 xs-mb-50">
                <div class="row mt-20">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font default-color">Notre adresse</h2>
                            <p class="mt-30">4, Avenue de la Justice, Q/ Cliniques
                                <br>C/ Gombe, Kinshasa
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font default-color">Numéros de téléphone</h2>
                            <p class="mb-0 mt-30">Appels directs : +243 89 14 88 154</p>
                            <p class="mb-0">WhatsApp : +243 98 07 81 589</p>
                        </div>
                    </div>
                </div>
                <div class="row mt-20">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font default-color">Notre e-mail</h2>
                            <p class="mb-0 mt-30">Information : info&#64;mazabu.com</p>
                            <p class="mb-0">Devis : devis&#64;mazabu.com</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font default-color">Service Technique</h2>
                            <p class="mb-0 mt-30">Support : support&#64;mazabu.com</p>
                        </div>
                    </div>
                </div>
                <div class="row mt-20">
                    <div class="col-md-12 social-icons-style-01">
                        <ul class="md-icon left-icon">
                            <li *ngFor="let social of socialMedia">
                                <a [ngClass]="social.iconClass" href="javascript:void(0)"><i
                                        [ngClass]="social.icon"></i></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
                <form (submit)="sendEmail($event)" class="contact-form-style-01" #contactForm="ngForm">
                    <div class="row">
                        <div class="col-md-6 col-sm-6">
                            <div class="form-group">
                                <label class="visually-hidden" for="user_name">Nom</label>
                                <input type="text" minlength="2" maxlength="15"
                                    [class.is-invalid]="userName.invalid && userName.touched" name="user_name"
                                    class="md-input" id="name" placeholder="Nom *" [(ngModel)]="formData.user_name"
                                    #userName="ngModel" required>
                                <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mb-10">
                                    Le nom est obligatoire..
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="mb-3">
                                <label class="visually-hidden" for="user_email">E-mail</label>
                                <input type="email" minlength="2" maxlength="35"
                                    [class.is-invalid]="userEmail.invalid && userEmail.touched" name="user_email"
                                    class="md-input" id="email" placeholder="E-mail *" [(ngModel)]="formData.user_email"
                                    #userEmail="ngModel" required email>
                                <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mb-10">
                                    Une adresse e-mail valide est requise.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12">
                            <div class="mb-3">
                                <label class="visually-hidden" for="message">Détails du projet</label>
                                <textarea name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched"
                                    class="md-textarea" id="message" rows="7" placeholder="Détails du projet *"
                                    [(ngModel)]="formData.message" #userMessage="ngModel" required></textarea>
                                <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                                    Les détails du projet sont requis.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12">
                            <div class="text-left mt-20">
                                <button type="submit" name="submit"
                                    class="btn btn-outline btn-md btn-circle btn-animate remove-margin"
                                    [disabled]="contactForm.invalid" value="Send">
                                    <span>Envoyer <i class="ion-android-arrow-forward"></i></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>
</section>
